import { EnvironmentProviders, inject, makeEnvironmentProviders, provideAppInitializer } from '@angular/core';
import { MatIconRegistry } from '@angular/material/icon';
import { DomSanitizer } from '@angular/platform-browser';

/** Espace de noms des icônes propres à l'AAP : `<mat-icon svgIcon="aap:logout">`. */
export const AAP_ICON_NAMESPACE = 'aap';

/**
 * Enregistre le jeu d'icônes de l'AAP auprès de `MatIconRegistry`.
 *
 * Le thème Pégase enregistre déjà ses propres jeux partagés (`PcscolIconsModule`) ;
 * celles-ci sont spécifiques aux modules apprenant, d'où un espace de noms dédié
 * plutôt qu'un ajout au thème, qui les ferait porter par toutes les applications
 * gestionnaire sans usage.
 *
 * Les tracés du sprite utilisent `currentColor` : la couleur et l'état de survol
 * se pilotent en CSS avec les tokens du thème, sans second fichier ni écouteur
 * de souris.
 */
export function provideAapIcons(): EnvironmentProviders {
  return makeEnvironmentProviders([
    provideAppInitializer(() => {
      const registry = inject(MatIconRegistry);
      const sanitizer = inject(DomSanitizer);

      registry.addSvgIconSetInNamespace(
        AAP_ICON_NAMESPACE,
        sanitizer.bypassSecurityTrustResourceUrl('assets/icons/aap-icons.svg'),
      );
    }),
  ]);
}
